"use client";
import { useEffect, useState } from "react";
import ImageModal from "~/components/image-components/ImageModal";

const ImageLightbox = ({
    urls,
    activeUrl,
}: {
    urls: string[];
    activeUrl: string | null;
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNext = () => {
        if (currentIndex === urls.length - 1) {
            setCurrentIndex(0);
            return;
        }
        setCurrentIndex(currentIndex + 1);
    };

    const handlePrevious = () => {
        if (currentIndex === 0) {
            setCurrentIndex(urls.length - 1);
            return;
        }
        setCurrentIndex(currentIndex - 1);
    };

    useEffect(() => {
        if (!activeUrl) return;
        setCurrentIndex(urls.indexOf(activeUrl));
        setIsModalOpen(true);
    }, [activeUrl]);

    return (
        <>
            {isModalOpen && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center">
                    {/* TODO PROPER Z AXIS CONTEXTS THIS IS GAY*/}
                    <ImageModal
                        src={urls[currentIndex]!}
                        alt={urls[currentIndex]!}
                        onNext={handleNext}
                        onPrevious={handlePrevious}
                        onClose={() => setIsModalOpen(false)}
                    />
                </div>
            )}
        </>
    );
};

export default ImageLightbox;
